import {
  AuthForm,
  ChoosePaymentMethod,
  ChoosePlan,
  MakePayment,
} from "../pages";

import creditFlags from "../assets/flags_credit.svg";
import credit from "../assets/iCredito.png";
import pixLogo from "../assets/pix-logo-cyan.svg";

export const STEPS_NAME = {
  VERIFY_CLIENT: "verify-client",
  CHOOSE_PLAN: "choose-plan",
  CHOOSE_PAYMENT: "choose-payment",
  MAKE_PAYMENT: "make-payment",
};

export const QR_CODE_ACTIONS_CONFIG = {
  STORAGE_KEY: "@qrCodeActions",
  STEPS: [
    {
      path: STEPS_NAME.VERIFY_CLIENT,
      component: AuthForm,
    },
    {
      path: STEPS_NAME.CHOOSE_PLAN,
      component: ChoosePlan,
    },
    {
      path: STEPS_NAME.CHOOSE_PAYMENT,
      component: ChoosePaymentMethod,
    },
    {
      path: STEPS_NAME.MAKE_PAYMENT,
      component: MakePayment,
    },
  ],
  BASE_PATH: "/actions-qrcode",
  PAYMENT_METHODS: [
    {
      id: "CARTAO",
      name: "Crédito",
      image: credit,
      type: "CREDIT",
      flags: creditFlags,
    },
    {
      id: "PIX",
      name: "Pix",
      image: pixLogo,
      type: "PIX",
    },
  ],
  HIDE_HEADER: [STEPS_NAME.VERIFY_CLIENT],
  ALLOW_PROGRAM: false,
  AUTH_TYPE: "manual",
  ALLOW_CHANGE_RECEIPT_DATA: true
};

export const SMS_ACTIONS_CONFIG = {
  STORAGE_KEY: "@smsActions",
  STEPS: [
    {
      path: STEPS_NAME.CHOOSE_PAYMENT,
      component: ChoosePaymentMethod,
    },
    {
      path: STEPS_NAME.MAKE_PAYMENT,
      component: MakePayment,
    },
  ],
  BASE_PATH: "/checkout",
  PAYMENT_METHODS: [
    {
      id: "CARTAO",
      name: "Crédito",
      image: credit,
      type: "CREDIT",
      flags: creditFlags,
    },
    {
      id: "PIX",
      name: "Pix",
      image: pixLogo,
      type: "PIX",
    },
  ],
  HIDE_HEADER_BACK: [STEPS_NAME.CHOOSE_PAYMENT],
  ALLOW_PROGRAM: false,
  AUTH_TYPE: "token",
  ALLOW_CHANGE_RECEIPT_DATA: false
};

export const SMART_CONTROL_CONFIG = {
  STORAGE_KEY: "@smartControlActions",
  STEPS: [
    {
      path: STEPS_NAME.VERIFY_CLIENT,
      component: AuthForm,
    },
    {
      path: STEPS_NAME.CHOOSE_PLAN,
      component: ChoosePlan,
    },
    {
      path: STEPS_NAME.CHOOSE_PAYMENT,
      component: ChoosePaymentMethod,
    },
    {
      path: STEPS_NAME.MAKE_PAYMENT,
      component: MakePayment,
    },
  ],
  BASE_PATH: "/actions-qrcode-ci",
  PAYMENT_METHODS: [
    {
      id: "CARTAO",
      name: "Crédito",
      image: credit,
      type: "CREDIT",
      flags: creditFlags,
    },
  ],
  HIDE_HEADER: [STEPS_NAME.VERIFY_CLIENT],
  GET_VALUES_ENDPOINT: "/v1/GetValuesPlanoInteligente",
  ALLOW_PROGRAM: true,
  AUTH_TYPE: "manual",
  ALLOW_CHANGE_RECEIPT_DATA: true
};
